/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface Schematisation
 */
export interface Schematisation {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The unique_id of an organisation
   */
  owner?: string;
  /**
   *
   */
  name: string;
  /**
   * The internal name (only superusers can modify)
   */
  slug?: string;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  meta?: any | null;
  /**
   * The user that created the schematisation (only superusers can modify this field)
   */
  createdBy?: string;
  /**
   *
   */
  readonly createdByFirstName?: string | null;
  /**
   *
   */
  readonly createdByLastName?: string | null;
  /**
   * The creation date and time (only superusers can modify)
   */
  created?: Date;
  /**
   *
   */
  readonly archived?: Date | null;
  /**
   *
   */
  readonly lastUpdated?: Date | null;
  /**
   * Automatically calculated.
   */
  readonly storageUsage?: number;
  /**
   *
   */
  readonly threedimodelLimit?: number;
  /**
   *
   */
  readonly latestRevisionNr?: number | null;
  /**
   * ID of the project in Rana. (only superusers can modify this field)
   */
  ranaProjectId?: string | null;
  /**
   *
   */
  readonly ranaTenantId?: string | null;
}

/**
 * Check if a given object implements the Schematisation interface.
 */
export function instanceOfSchematisation(value: object): value is Schematisation {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function SchematisationFromJSON(json: any): Schematisation {
  return SchematisationFromJSONTyped(json, false);
}

export function SchematisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Schematisation {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    owner: json["owner"] == null ? undefined : json["owner"],
    name: json["name"],
    slug: json["slug"] == null ? undefined : json["slug"],
    tags: json["tags"] == null ? undefined : json["tags"],
    meta: json["meta"] === undefined ? undefined : json["meta"] === null ? null : json["meta"],
    createdBy: json["created_by"] == null ? undefined : json["created_by"],
    createdByFirstName:
      json["created_by_first_name"] === undefined
        ? undefined
        : json["created_by_first_name"] === null
        ? null
        : json["created_by_first_name"],
    createdByLastName:
      json["created_by_last_name"] === undefined
        ? undefined
        : json["created_by_last_name"] === null
        ? null
        : json["created_by_last_name"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    archived:
      json["archived"] === undefined
        ? undefined
        : json["archived"] === null
        ? null
        : parseDateTime(json["archived"]),
    lastUpdated:
      json["last_updated"] === undefined
        ? undefined
        : json["last_updated"] === null
        ? null
        : parseDateTime(json["last_updated"]),
    storageUsage: json["storage_usage"] == null ? undefined : json["storage_usage"],
    threedimodelLimit: json["threedimodel_limit"] == null ? undefined : json["threedimodel_limit"],
    latestRevisionNr:
      json["latest_revision_nr"] === undefined
        ? undefined
        : json["latest_revision_nr"] === null
        ? null
        : json["latest_revision_nr"],
    ranaProjectId:
      json["rana_project_id"] === undefined
        ? undefined
        : json["rana_project_id"] === null
        ? null
        : json["rana_project_id"],
    ranaTenantId:
      json["rana_tenant_id"] === undefined
        ? undefined
        : json["rana_tenant_id"] === null
        ? null
        : json["rana_tenant_id"],
  };
}

export function SchematisationToJSON(json: any): Schematisation {
  return SchematisationToJSONTyped(json, false);
}

export function SchematisationToJSONTyped(
  value?: Omit<
    Schematisation,
    | "url"
    | "id"
    | "createdByFirstName"
    | "createdByLastName"
    | "archived"
    | "lastUpdated"
    | "storageUsage"
    | "threedimodelLimit"
    | "latestRevisionNr"
    | "ranaTenantId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    owner: value["owner"],
    name: value["name"],
    slug: value["slug"],
    tags: value["tags"],
    meta: value["meta"],
    created_by: value["createdBy"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    rana_project_id: value["ranaProjectId"],
  };
}
